import React from 'react'
import { DashboardLayout } from '../layouts'
import { AgentsTopbar } from '../components'
import { AgentsContainer } from '../containers'

function Agents() {

    // useAuthentication();

    return (

        <DashboardLayout>
            <div>

                <AgentsTopbar />
                <AgentsContainer/>
            </div>
        </DashboardLayout>
    )
}

export default Agents